import React from 'react'

export default function Footer(){
    return (
        <div>
            <footer>
                <p>&copy; 2023 Matcha Tea Heaven. All rights reserved.</p>
            </footer>
        </div>
    )
}